// // import React from "react";
// // import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// // import Navbar from "./component/navbar";
// // // import Hero from "./pages/hero/hero";
// // import Home from "./pages/home/home";
// // import About from "./pages/about/about";
// // import Contact from "./pages/contact/contact";
// // import Popup from "./component/popup/popup";

// // function App() {
// //   return (
// //     <Router>
// //       <Navbar />

// //       <Routes>

// //         <Route path="/" element={<Home />} />
// //         <Route path="/about" element={<About />} />
// //         <Route path="/contact" element={<Contact />} />
// //       </Routes>
// //     </Router>
// //   );
// // }

// // export default App;






// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import Navbar from "./component/navbar";
// import Home from "./pages/home/home";
// import About from "./pages/about/about";
// import Contact from "./pages/contact/contact";
// import Popup from "./component/popup/popup";
// import ScrollToTop from "./component/scrollToTop";

// function App() {
//   return (
//     <Router>
// <ScrollToTop />
//       {/* ✅ POPUP MUST BE HERE (GLOBAL LEVEL) */}
//       <Popup />

//       <Navbar />

//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/contact" element={<Contact />} />
//       </Routes>

//     </Router>
//   );
// }

// export default App;


import React from "react";

import Navbar from "./component/navbar";
import Home from "./pages/home/home";
import Popup from "./component/popup/popup";

function App() {
  return (
    <>
      {/* GLOBAL POPUP */}
      <Popup />

      {/* NAVBAR */}
      <Navbar />

      {/* SINGLE PAGE ONLY */}
      <Home />
    </>
  );
}

export default App;